import '../styles/index.scss';
import { HashRouter, Route, Switch, RouteComponentProps } from 'react-router-dom'
import routes from '../config/routes';
import Navigation from './navigation';
import Footer from './footer'

const CLASS_NAME = 'application';

const Application = () => {
    return (<div className={CLASS_NAME}>
        <HashRouter>
            <Navigation />
            <Switch>
                {routes.map((route, index) => {
                    return <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        render={(props: RouteComponentProps<any>) => (
                            <route.component
                                {...props}
                                {...route.props}
                            />)}
                    />
                })}
            </Switch>
            <Footer />
        </HashRouter>
    </div>)
}

export default Application;